
  import { defineComponent, PropType } from 'vue';

  import IndicatorCard from '@/common/components/redesigned/IndicatorCard.vue';
  import Tooltip from '@/common/ui/Tooltip.vue';
  import { wordDeclension } from '@/common/utils/wordDeclension';

  import { DASHBOARDS_INDICATOR_WORD_FORMS } from '../../../constants/dashboards';
  import type { TDashboardsIndicatorStatistic } from '../../../types/dashboards';
  import type { TIndicatorsColor, TVariant } from './types';

  export default defineComponent({
    name: 'DashboardsCard',
    components: {
      IndicatorCard,
      Tooltip,
    },
    emits: ['click'],
    props: {
      card: {
        type: Object as PropType<TDashboardsIndicatorStatistic>,
        required: true,
      },
      variant: {
        type: String as PropType<TVariant>,
        default: 'link',
        validator: (value: TVariant) => ['link', 'simple-card', 'default'].includes(value),
      },
      indicatorsColor: {
        type: String as PropType<TIndicatorsColor>,
        default: 'default',
      },
      link: {
        type: String as PropType<string>,
        default: '',
      },
      isShowAPPG: {
        type: Boolean,
        default: true,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      isClickable: {
        type: Boolean,
        default: false,
      },
      isAmountDifferenceInverted: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      // ? бэк присылает слово в одной форме, склоняем его по значению показателя
      getCardText(): string {
        const forms = DASHBOARDS_INDICATOR_WORD_FORMS[this.card.text?.trim() ?? ''];

        return forms ? wordDeclension(this.card.amount, forms) : this.card.text ?? '';
      },
      getAmountDifference() {
        if (this.card.oldAmount == undefined) return 0;

        if (this.isAmountDifferenceInverted) return this.card.oldAmount - this.card.amount;

        return this.card.amount - this.card.oldAmount;
      },
      getAmountDifferenceAbs() {
        return Math.abs(this.getAmountDifference);
      },
      getAmountDifferenceValue() {
        const sign = this.getAmountDifference === 0 ? '' : this.getAmountDifference > 0 ? '+' : '-';
        return `${sign}${this.getAmountDifferenceAbs}`;
      },
      getTextColor() {
        if (this.getAmountDifference === 0) return 'text-gray';
        return this.getAmountDifference > 0 ? 'text-green' : 'text-red';
      },
      getArrowIcon() {
        if (this.getAmountDifference === 0) return 'fa-equals';
        return this.getAmountDifference > 0 ? 'fa-arrow-up' : 'fa-arrow-down';
      },
      isLinkVariant() {
        return this.variant === 'link';
      },
      isSimpleCardVariant() {
        return this.variant === 'simple-card';
      },
    },
    methods: {
      handleCardClick() {
        this.$emit('click');
      },
    },
  });
